type PipeFunction = (...args: any[]) => any

export const pipe = (...functions: PipeFunction[]) =>
  (initialValue: any) =>
    functions.reduce((tempResult, argFunction) => argFunction(tempResult), initialValue)
